import { useContext, useRef, useEffect } from 'react'
import { Box, ListItem, Typography } from '@mui/material'
import RightPanel from '../rightPanel'
import SunnyMessage from './sunnyMessage'
import UserMessage from './userMessage'
import { DataContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain } from '../../../services/constants'
import { sendViewAnalytics } from '../../common/util/util'

export default function AiChatHelp() {
  const divRef: any = useRef();
  const data = useContext(DataContext)

  const scrollToElement = () => {
    const {current} = divRef
     if (current){
       current.scrollIntoView({block: 'end'})
     }
  }

  useEffect(()=>{
      scrollToElement()
      if(data?.chat.chatWindow===10) window.scrollTo(0,0)
  }, [data?.chat.chatWindow])

  useEffect(()=>{
    sendViewAnalytics('/help', {
            domain: analyticsDomain.assistant,
            name: analyticsPage.assistant
          })
  },[])

  return (
    <RightPanel title="Help">
      <Box sx={{ 
        backgroundColor:'sz.colors.gray100',
        maxWidth: {
          xs:'100%', 
          sm:'400px', 
          md:'400px', 
          lg:'400px' 
        },
        height: `150vh`
       }} >
        <Box display="flex" 
              justifyContent={"flex-start"} 
              alignItems={"flex-start"} 
              flexDirection={"column"} 
              height={`${data?.chat.chatWindow}0vh`}
              maxWidth="100%"
              width = '100%'
              sx={{  
                backgroundColor:'sz.colors.gray100',
                overflowY: 'auto' 
              }}
              onClick={scrollToElement} 
              >
        {/* Chat Area */}
          <Box sx={{ width: '100%', maxWidth:'100%' }} >
              {(Object.entries(data.chat?.messages) || [])
                .map((m: any[], i: number)=>{
                  if(m[1].from==='sunny') return (
                    <ListItem key={i} sx={{ 
                          justifyContent: 'flex-start'
                        }}>
                      <SunnyMessage ms={m[1].timeMs} 
                                    message={m[1].message} />
                    </ListItem>
                  )
                  if(m[1].from==='user') return (
                    <ListItem key={i} sx={{ 
                            justifyContent: 'flex-end'
                          }}>
                      <UserMessage ms={m[1].timeMs}  
                                    message={m[1].message} />
                    </ListItem>
                  )
                  if(m[1].from==='system') return (
                    <Box display={"flex"} 
                        flexDirection={"row"} 
                        justifyContent={"center"} 
                        width="100%">
                      <Typography pt={custom.spacing.xxs} 
                        variant="szBody.Regular.xSmall" 
                        color={"text.tertiary"}>
                        {m[1].message}
                      </Typography>
                    </Box>
                  )
                  return <></>
              })}
              <Box ref={divRef} height={'200px'} 
                  sx={{  
                    backgroundColor:'sz.colors.gray100' 
                  }} />
          </Box>
        </Box>
      </Box>
    </RightPanel>
  )
}
